import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home_header_main" }
const _hoisted_2 = { class: "home_logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "header_main_nav_ul" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "header_account_wrap" }
const _hoisted_7 = { class: "header_dropdown" }
const _hoisted_8 = { class: "header_dropdown" }

import { computed, ref } from 'vue';
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { Layout } from 'ant-design-vue';
import AppLink from '@/components/AppLink.vue';
import { getHelperUrl, removeToken } from '@/plugins/cookie';
import { useLiveStore } from '@/pinia/live';
import { useHomeStore } from '@/pinia/home';
import { useConsoleStore } from '@/pinia/console';

interface IProps {
  isCollapsed: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'HelperHeader',
  props: {
    isCollapsed: { type: Boolean }
  },
  emits: ['switch'],
  setup(__props: any, { emit: __emit }) {

const aLayoutHeader = Layout.Header;

const store = useStore();
const router = useRouter();
const props = __props;
const emit = __emit;
const consoleStore = useConsoleStore();

const customLayoutStyle = computed(() => store.state.home.customLayoutStyle);

const liveStore = useLiveStore();
const homeStore = useHomeStore();
const isLanguageStudio = computed(() => liveStore.liveInfo.mode === 5 && liveStore.liveInfo.id === liveStore.liveInfo.studio_pid);
const isStreamStudio = computed(() => liveStore.liveInfo.mode === 4 && liveStore.liveInfo.id === liveStore.liveInfo.studio_pid);
const consoleMenu = computed(() =>
  [
    {
      path: `/live_set/${route.params.studioId}/broad_cast_control`,
      name: 'BroadCastControl',
      title: '基础设置',
      icon: 'settings',
      routeParent: 'liveSet',
      visibel: Boolean(store.state.user.helperInfo.set),
    },
    {
      path: `/pages_editor/${route.params.studioId}/page_director`,
      name: 'PageDirector',
      title: '页面配置',
      icon: 'browser',
      routeParent: 'PagesEditor',
      visibel: Boolean(store.state.user.helperInfo.set) && !isLanguageStudio.value,
    },
    {
      path: `/market/${route.params.studioId}/${isLanguageStudio.value ? 'red_envelope_rain' : 'mutually_engage'}`,
      name: `${isLanguageStudio.value ? 'MutuallyEngage' : 'MutuallyEngage'}`,
      title: '营销互动',
      icon: 'menu_present',
      routeParent: 'Market',
      visibel: Boolean(store.state.user.helperInfo.set),
    },
    {
      path: `/view_warrent/${route.params.studioId}/authorization`,
      name: 'Authorization',
      title: '观看授权',
      icon: 'warrent_view',
      routeParent: 'viewWarrent',
      visibel: Boolean(store.state.user.helperInfo.set),
    },
    {
      path: `/playback/${route.params.studioId}/playback_settings`,
      name: 'playBack',
      title: '视频回放',
      icon: 'menu_playblack',
      routeParent: 'PlayBack',
      visibel: Boolean(store.state.user.helperInfo.set) && !isStreamStudio.value && !isLanguageStudio.value,
    },
    {
      path: `/data_center/${route.params.studioId}/${homeStore.funcData['LiveData'] ? 'live' : 'questionnaire'}`,
      name: 'LiveData',
      title: '数据统计',
      icon: 'browser',
      routeParent: 'DataCenter',
      visibel: Boolean(store.state.user.helperInfo.data) && !isStreamStudio.value,
    },
    {
      path: `/media/videos/${route.params.studioId}`,
      name: 'MediaVideos',
      title: '媒体库',
      icon: '',
      routeParent: 'Media',
      visibel: Boolean(store.state.user.helperInfo.set),
    },
    // {
    //   path: `/media/cache/${route.params.studioId}`,
    //   name: 'LiveCache',
    //   title: '直播缓存',
    //   icon: '',
    //   visibel: Boolean(store.state.user.helperInfo.set),
    // },
    {
      path: `/console/${route.params.studioId}`,
      name: 'Console',
      title: '发起直播',
      icon: 'settings',
      visibel: true,
    },
  ].filter((e) => e.visibel === true)
);

// const HomeLogo = computed(() => store.state.home.customData.top_logo_url);
const ConsoleLogo = computed(() =>
  store.state.home.customStatus && store.state.home.customData.top_logo_url !== process.env.VUE_APP_OTHER_LINK+'/top_logo.svg'
    ? store.state.home.customData.top_logo_url
    : store.state.home.black_top_logo_url
);
const collapsedIcon = computed(() => (props.isCollapsed ? 'MenuUnfoldOutlined' : 'MenuFoldOutlined'));

const route = useRoute();
const openKeys = ref((route.meta.routeParent as string) ?? 'Home');

onBeforeRouteUpdate((to) => {
  // routerWatch(to.meta.routeParent as string);
  openKeys.value = (to.meta?.routeParent as string) ?? 'Home';
});

const onTabChange = (name: any): void => {
  openKeys.value = name;
};

const onCollapsedTrigger = () => {
  emit('switch');
};
const onExit = () => {
  router.push(getHelperUrl()?.url);
  removeToken();
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_unref(aLayoutHeader), { class: "home_header_wrap" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("div", {
            class: "home_header_toggle",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onCollapsedTrigger()))
          }, [
            _createVNode(_component_svg_icon, {
              class: "trigger",
              "icon-class": collapsedIcon.value
            }, null, 8, ["icon-class"])
          ], 512), [
            [_vShow, !customLayoutStyle.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("img", {
              src: ConsoleLogo.value,
              alt: ""
            }, null, 8, _hoisted_3), [
              [_vShow, ConsoleLogo.value]
            ])
          ], 512), [
            [_vShow, customLayoutStyle.value]
          ]),
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(consoleMenu.value, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.path,
                class: "header_nav_li",
                onClick: ($event: any) => (onTabChange(item.name))
              }, [
                _createVNode(AppLink, {
                  class: _normalizeClass(["link", item.name === openKeys.value || item.routeParent === openKeys.value ? 'on' : '']),
                  to: item.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "to"])
              ], 8, _hoisted_5))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_svg_icon, { "icon-class": "helper_account" }),
              _createTextVNode("  " + _toDisplayString(_unref(consoleStore).authority.name), 1)
            ]),
            _createVNode(_component_a_button, {
              type: "link",
              onClick: onExit,
              class: "header_dropdown_btn"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, { "icon-class": "helper_close" }),
                _cache[1] || (_cache[1] = _createTextVNode(" 退出", -1))
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})